import {
  AfterViewInit,
  Component,
  DoCheck,
  Input,
  KeyValueDiffer,
  KeyValueDiffers,
  OnDestroy,
  OnInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {
  ECaseConfirmDialogComponent,
  EcaseHttpService,
  ECaseNumberFormatterPipe,
  ECaseSnackBarService,
  ECaseUtils,
  ECaseUtilsGlobal, LovDataService,
  PendingChangesGuard,
  RefreshDataService
} from 'synto-common';
import { Subscription } from 'rxjs/internal/Subscription';
import { DialogService } from '../../formbuilderForms/form/dialog.service';
import cloneDeep from "lodash/cloneDeep";
import { PageEvent } from "@angular/material/paginator";

/*
  Properties of confChange
  hideYearsExpenditure - Hides Year rows in main table and in the summary table
  showSubCategoryInSummary - Shows Sub-categories in summary table
  subBlocks.hideCellInDetailView - Hides component in the main table
  showCategoriesTotal - Shows sub-total for categories in the main table
  showSubCategoriesTotal - Shows sub-total for sub-categories in the main table
  numberOfYears - Years quantity
 */
@Component({
  selector: 'fb-budget-table',
  templateUrl: './fb-budget-table.component.html',
  styleUrls: ['./fb-budget-table.component.scss']
})
export class FbBudgetTableComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() selectedLanguage: any;
  @Input() isValidHtml: boolean;
  @Input() isValidTable: boolean;
  @Input() isValidTableReadonly: boolean;
  @Input() isFormRevisionMode: boolean;
  @Input() showSaveNavBar: boolean;
  @Input() bphChange: any;
  @Input() globalPrj: any;
  @Input() confChange: any;
  @Input() globalConf: any;
  @Input() selectedSectionId: string;
  @Input() offlineModeEnabled;
  @Input() blockIndex: number;
  @Input() teamTableIndex: number;
  @Input() sections;
  @Input() teamTableBlockName: string;
  @Input() teamTableNestedTableBlockName: string;
  originalValueForShowSaveNavBar = true;
  showDetails = false;
  showAddEditTableForm: boolean = false;
  selectedTableRowIndex = -1;
  selectedTable: any;
  copyBlockData: any;
  indexOfEditedRow;
  subscription: Subscription;
  formValidationSubscription: Subscription;
  globalComponent;
  widthDividerForDynamicWidth = 1;
  tableConfChange;
  isDragActive: boolean;
  rowIndexBeingDragged: number;
  beforeFilteringRows = [];
  showFilteredImage = true;
  pageSizeOptions = [5, 10, 25, 100];
  pageSize = 10;
  pageIndex = 0;
  hideEditButton: boolean;
  tempRow: any;
  columnAsRowColspan = 4; // Default value. Adjust based on the number of columns in the table.
  expRowCompArr = [];
  expRowCompArrDetailExcludeRevision = [];
  compsDetailArr = [];
  filteredSubBlocksCache: any;
  filteredSubBlocksDetailedCache: any;
  filteredSubBlocksColumnAsRowCache: any;
  caseApplicationPiTeamId: any;
  // Keep uploads state to restore when canceling a row edit
  tempDocIds: any;
  tempUploadToBeDeleted: any;

  constructor(private translate: TranslateService, private matDialog: MatDialog, private eCaseNumberFormatterPipe: ECaseNumberFormatterPipe, private eCaseHttpService: EcaseHttpService,
    private refreshDataService: RefreshDataService, private dialogService: DialogService, private eCaseSnackBarService: ECaseSnackBarService,
    private pendingChangesGuard: PendingChangesGuard, private lovDataService: LovDataService) {
    this.bphChange = {};
    this.bphChange.value = {};
    this.bphChange.value.label = {};
    this.bphChange.error = {};
    this.bphChange.source = {};
    this.isValidHtml = true;
    this.isValidTable = false;
    this.isValidTableReadonly = false;
    this.tableConfChange = this.confChange;
    this.hideEditButton = false;
  }


  openDialog(confChange) {
    const dialogRef = this.matDialog.open(DialogComponent, {
      width: '600px',
      data: { dialog: confChange.dialogText, selectedLanguage: this.selectedLanguage }
    });
    console.log('donee');
  }

  onDrop(event): void {
    if (this.confChange.isTablePaginated) {
      const previousIndex = event.previousIndex;
      const currentIndex = event.currentIndex;
      console.log(previousIndex);
      console.log(currentIndex);
      if (this.confChange.onRowDragEndFunction) {
        this.confChange.onRowDragEndFunction(this.globalPrj, this.globalConf, previousIndex, currentIndex, this.selectedLanguage);
      }
      if (this.pageIndex === 0) {
        this.bphChange.rows = this.bphChange.rows.map((row, index) => {
          row.isHidden = index > (this.pageSize - 1);
          return row;
        });
      } else {
        this.bphChange.rows = this.bphChange.rows.map((row, index) => {
          row.isHidden = (index < ((this.pageIndex * this.pageSize) - 1)) || (index > ((this.pageIndex * this.pageSize) + this.pageSize - 1));
          return row;
        });
      }
      if (Math.abs(currentIndex - previousIndex) === 1) {
        [this.bphChange.rows[currentIndex], this.bphChange.rows[previousIndex]] = [this.bphChange.rows[previousIndex], this.bphChange.rows[currentIndex]];
      } else {
        [this.bphChange.rows[currentIndex], this.bphChange.rows[previousIndex]] = [this.bphChange.rows[previousIndex], this.bphChange.rows[currentIndex]];
        // previousIndex >= currentIndex ? this.bphChange.rows.splice(currentIndex, 0, this.bphChange.rows.splice(previousIndex, 1)[0]) : this.bphChange.rows.splice(currentIndex - 1, 0, this.bphChange.rows.splice(previousIndex, 1)[0]);
      }
    } else {
      if (this.confChange.onRowDragEndFunction) {
        this.confChange.onRowDragEndFunction(this.globalPrj, this.globalConf, event.previousIndex, event.currentIndex, this.selectedLanguage);
      }
      if (Math.abs(event.currentIndex - event.previousIndex) === 1) {
        [this.bphChange.rows[event.currentIndex], this.bphChange.rows[event.previousIndex]] = [this.bphChange.rows[event.previousIndex], this.bphChange.rows[event.currentIndex]];
      } else {
        event.previousIndex >= event.currentIndex ? this.bphChange.rows.splice(event.currentIndex, 0, this.bphChange.rows.splice(event.previousIndex, 1)[0]) : this.bphChange.rows.splice(event.currentIndex - 1, 0, this.bphChange.rows.splice(event.previousIndex, 1)[0]);
      }
    }

    this.pendingChangesGuard.isPristine = false;
    this.isDragActive = false;
  }

  updateDragStatus(event, rowIndex): void {
    this.rowIndexBeingDragged = rowIndex;
    this.isDragActive = true;
    const documentInputField = document.getElementsByClassName('cdk-drag-preview')[0];
    if (documentInputField) {
      const curStyle = documentInputField.getAttribute('class');
      if (!curStyle.includes(' inDrag')) {
        documentInputField.setAttribute('class', ((curStyle ? curStyle : '') + ' inDrag'));
      }
    }
  }

  resetFilters(): void {
    console.log("got inside reset filter")
    this.bphChange.rows = cloneDeep(this.beforeFilteringRows);
    this.pageIndex = 0;
    if (this.confChange.isTablePaginated) {
      this.bphChange.rows = this.bphChange.rows.map((row, index) => {
        row.isHidden = index > (this.pageSize - 1);
        return row;
      });
    }
    this.showFilteredImage = true;
    this.confChange.subBlocks.forEach(subBlock => {
      subBlock.valueToFilter = '';
    });
  }

  isFilterFieldVisible(subBlock): boolean {
    return subBlock.type === 'text' || subBlock.type === 'statictext' || subBlock.type === 'select' || subBlock.type === 'AutoComplete';
  }

  applyFilter(event, subBlock): void {
    if (this.confChange.isColumnsFiltered) {
      if (!event.target.value || event.target.value === '') {
        this.resetFilters();
      } else {
        this.pageIndex = 0;
        //this.beforeFilteringRows = this.bphChange.rows;
        this.bphChange.rows = this.bphChange.rows.filter(row => {
          if (subBlock.type === 'text' || subBlock.type === 'statictext') {
            if (!row[subBlock.name].value) {
              row[subBlock.name].value = ''
            }
            return row[subBlock.name].value.toString().toLowerCase().includes(event.target.value.toLowerCase());
          } else if (subBlock.type === 'select' || subBlock.type === 'AutoComplete') {
            if (!row[subBlock.name].value) {
              row[subBlock.name].value = {};
              row[subBlock.name].value.label = {};
              row[subBlock.name].value.label[this.selectedLanguage] = '';
            }
            if (!row[subBlock.name].value.label) {
              row[subBlock.name].value.label = {};
              row[subBlock.name].value.label[this.selectedLanguage] = '';
            }
            return row[subBlock.name].value.label[this.selectedLanguage].toLowerCase().includes(event.target.value.toLowerCase());
          } else {
            return true;
          }
        });
        if (this.confChange.isTablePaginated) {
          this.bphChange.rows = this.bphChange.rows.map((row, index) => {
            row.isHidden = index > (this.pageSize - 1);
            return row;
          });
        }
        this.showFilteredImage = false;
      }
    }
  }

  updatePagination(pageEvent: PageEvent): void {
    if (pageEvent.pageIndex === 0) {
      this.bphChange.rows = this.bphChange.rows.map((row, index) => {
        row.isHidden = index > (pageEvent.pageSize - 1);
        return row;
      });
    } else {
      this.bphChange.rows = this.bphChange.rows.map((row, index) => {
        row.isHidden = (index <= ((pageEvent.pageIndex * pageEvent.pageSize) - 1)) || (index > ((pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize - 1));
        return row;
      });
    }
  }

  sortRows(subBlock: any): void {
    if (subBlock.isSortable) {
      if (subBlock.sortDirection === 'asc') {
        subBlock.sortDirection = 'desc';
      } else if (subBlock.sortDirection === 'desc') {
        subBlock.sortDirection = 'asc';
      } else {
        subBlock.sortDirection = 'asc';
      }
      this.confChange.subBlocks.filter(e => e.name !== subBlock.name).forEach(block => {
        block.sortActive = false;
      })
      const direction = subBlock.sortDirection === 'asc' ? 1 : -1
      this.bphChange.rows = this.bphChange.rows.sort((a, b) => {
        if (subBlock.type === 'text' || subBlock.type === 'statictext') {
          if (!a[subBlock.name].value) {
            a[subBlock.name].value = ''
          }
          if (!b[subBlock.name].value) {
            b[subBlock.name].value = ''
          }
          return (direction * a[subBlock.name].value.toString().toLowerCase().localeCompare(b[subBlock.name].value.toString().toLowerCase()));
        } else if (subBlock.type === 'select' || subBlock.type === 'AutoComplete') {
          if (!a[subBlock.name].value) {
            a[subBlock.name].value = {};
            a[subBlock.name].value.label = {};
            a[subBlock.name].value.label[this.selectedLanguage] = '';
          }
          if (!a[subBlock.name].value.label) {
            a[subBlock.name].value.label = {};
            a[subBlock.name].value.label[this.selectedLanguage] = '';
          }
          if (!b[subBlock.name].value) {
            b[subBlock.name].value = {};
            b[subBlock.name].value.label = {};
            b[subBlock.name].value.label[this.selectedLanguage] = '';
          }
          if (!b[subBlock.name].value.label) {
            b[subBlock.name].value.label = {};
            b[subBlock.name].value.label[this.selectedLanguage] = '';
          }
          return (direction * a[subBlock.name].value.label[this.selectedLanguage].toString().toLowerCase().localeCompare(b[subBlock.name].value.label[this.selectedLanguage].toString().toLowerCase()));
        } else {
          return 0
        }
      });
      this.pageIndex = 0;
      if (this.confChange.isTablePaginated) {
        this.bphChange.rows = this.bphChange.rows.map((row, index) => {
          row.isHidden = index > (this.pageSize - 1);
          return row;
        });
      }
      subBlock.sortActive = true;
    }
  }

  generateBudgetTables(): void {
    if (!this.bphChange.budgetTables) {
      this.bphChange.budgetTables = []
    }

    if (this.confChange.budgetPerTeam) {
      console.log(`//---------// BUDGET PER TEAM TRUE //-----------//\nPRJ -> ${this.globalPrj}`);
      if (this.confChange.tableSection && this.confChange.tableComponent && this.confChange.tableSubComponent && this.confChange.budgetPerTeamType == 'table') {
        this.globalPrj[this.confChange.tableSection][this.confChange.tableComponent].rows.forEach((row, index) => {
          let teamName = row[this.confChange.tableSubComponent].value;
          let teamData = row.autocomplete_leader_name?.value?.data;
          console.log(`//--//  TEAM NAME = ${teamName}\ncaseApplicationTeamId = ${row.caseApplicationTeamId}\nuniqueRowIndex = ${row.uniqueRowIndex}`);
          if (typeof teamName !== 'string') {
            teamName = teamName?.label != null ? teamName.label : teamName;
          }
          if (typeof teamName === 'string') {
            teamName = {
              'fr': teamName,
              'en': teamName,
              'ar': teamName
            };
          }
          // Always use a copy so we never mutate row[tableSubComponent].value (prevents duplicate "Team name: ..." on save/reopen)
          const labelCopy = teamName && typeof teamName === 'object' ? cloneDeep(teamName) : { fr: '', en: '', ar: '' };
          // first we look by id === uniqueRowIndex; if not — by caseApplicationTeamId
          let uniqueTable = this.bphChange.budgetTables.find(table => table.id === row.uniqueRowIndex);
          if (!uniqueTable && row.caseApplicationTeamId != null) {
            uniqueTable = this.bphChange.budgetTables.find(table =>
              table.caseApplicationTeamId != null &&
              String(table.caseApplicationTeamId) === String(row.caseApplicationTeamId)
            );
          }
          if (uniqueTable) {
            // Rename table only when label is not locked externally
            if (!uniqueTable.isLabelLocked) {
              uniqueTable.label = labelCopy;
              uniqueTable.labelLinesCache = {};
            }
            uniqueTable.caseApplicationTeamId = row.caseApplicationTeamId;
            uniqueTable.teamData = teamData;
          } else {
            // add table if it does not exist
            let hasOptionSelected = false;
            if (index === 0) {
              hasOptionSelected = true;
            }
            const newTable = this.getTableConfig(true, labelCopy, hasOptionSelected, row.uniqueRowIndex, row.caseApplicationTeamId);
            newTable.isLabelLocked = false;
            newTable.labelLinesCache = {};
            newTable.teamData = teamData;

            // Check if a table with the same teamData.VALUE and teamData.EMAIL already exists
            if (teamData && teamData.VALUE && teamData.EMAIL) {
              const existingTableIndex = this.bphChange.budgetTables.findIndex(table =>
                table.teamData &&
                table.teamData.VALUE === teamData.VALUE &&
                table.teamData.EMAIL === teamData.EMAIL
              );

              if (existingTableIndex !== -1) {
                // If the table already exists, replace everything except rows
                const existingRows = this.bphChange.budgetTables[existingTableIndex].rows;
                Object.assign(this.bphChange.budgetTables[existingTableIndex], newTable);
                this.bphChange.budgetTables[existingTableIndex].rows = existingRows;
              } else {
                // If the table doesn't exist, add a new one
                this.bphChange.budgetTables.push(newTable);
                this.bphChange.budgetTables[0].teamFunded = '1';
              }
            } else {
              // If teamData is missing, just add the table
              this.bphChange.budgetTables.push(newTable);
              this.bphChange.budgetTables[0].teamFunded = '1';
            }
          }
        });
      } else if (this.confChange.budgetPerTeamType == 'list') {
        this.globalPrj[this.selectedSectionId].budgetTableList.forEach((row, index) => {
          let teamName = row.teamName;
          const labelCopyList = (typeof teamName === 'object' && teamName != null) ? cloneDeep(teamName) : { fr: String(teamName ?? ''), en: String(teamName ?? ''), ar: String(teamName ?? '') };
          let uniqueTable = this.bphChange.budgetTables.find(table => table.id === row.uniqueRowIndex);
          if (!uniqueTable && row.caseApplicationTeamId != null) {
            uniqueTable = this.bphChange.budgetTables.find(table =>
              table.caseApplicationTeamId != null &&
              String(table.caseApplicationTeamId) === String(row.caseApplicationTeamId)
            );
          }
          if (uniqueTable) {
            // Rename table only when label is not locked externally
            if (!uniqueTable.isLabelLocked) {
              uniqueTable.label = labelCopyList;
              uniqueTable.labelLinesCache = {};
            }
            uniqueTable.caseApplicationTeamId = row.caseApplicationTeamId;
          } else {
            // add table if it does not exist
            let hasOptionSelected = false;
            if (index === 0) {
              hasOptionSelected = true;
            }
            const newTable = this.getTableConfig(true, labelCopyList, hasOptionSelected, row.uniqueRowIndex, row.caseApplicationTeamId);
            newTable.isLabelLocked = false;
            newTable.labelLinesCache = {};
            this.bphChange.budgetTables.push(newTable);
            this.bphChange.budgetTables[0].teamFunded = '1';
          }
        })
      }
    } else {
      if (this.bphChange.budgetTables.length === 0) {
        this.bphChange.budgetTables.push(this.getTableConfig());
      }
    }

    this.bphChange.budgetTables[0].teamFunded = '1';
  }

  removeBudgetTableDuplicates() {
    if (!this.bphChange?.budgetTables || !this.confChange.budgetPerTeam) return;
    const seen = new Set();
    this.bphChange.budgetTables = this.bphChange.budgetTables.filter(item => {
      const data = item.teamData;

      if (!data) return false;

      // Create a unique key from both VALUE and EMAIL
      const compositeKey = `${data.VALUE}|${data.EMAIL}`;

      if (seen.has(compositeKey)) {
        return false; // Found a duplicate, remove it
      }

      seen.add(compositeKey);
      return true; // Keep the first
    });
  }

  removeBudgetTablesForDeletedTeams(): void {
    // Check and remove budget tables for deleted teams
    if (this.confChange.budgetPerTeam &&
        this.confChange.tableSection &&
        this.confChange.tableComponent &&
        this.confChange.budgetPerTeamType == 'table' &&
        this.bphChange.budgetTables) {
      const teamRows = this.globalPrj[this.confChange.tableSection][this.confChange.tableComponent].rows || [];

      // Create an array of existing teams for quick lookup
      const existingTeams = teamRows.map(row => {
        if (row.autocomplete_leader_name?.value?.data) {
          return {
            VALUE: row.autocomplete_leader_name.value.data.VALUE,
            EMAIL: row.autocomplete_leader_name.value.data.EMAIL
          };
        }
        return null;
      }).filter(team => team !== null);

      // Remove tables for which there is no corresponding team
      this.bphChange.budgetTables = this.bphChange.budgetTables.filter(table => {
        if (!table.teamData) {
          // If the table has no teamData, keep it (for backward compatibility)
          return true;
        }

        // Check if there is a team with the same VALUE and EMAIL (team leader)
        // Priority is on team leader, not uniqueRowIndex
        const teamExists = existingTeams.some(team =>
          team.VALUE === table.teamData.VALUE &&
          team.EMAIL === table.teamData.EMAIL
        );

        return teamExists;
      });
    }
  }

  getTableConfig(showLabel = false, label: any = '', hasOptionSelected = true, id: any = false, caseApplicationTeamId: any = false) {
    if (typeof label === 'string') {
      label = {
        'fr': label,
        'en': label,
        'ar': label
      };
    }
    // Store a copy so table.label never shares reference with row value (prevents duplicate label on save/reopen)
    const labelStored = label && typeof label === 'object' ? cloneDeep(label) : { fr: '', en: '', ar: '' };
    const table = {
      'showLabel': showLabel,
      'label': labelStored,
      'hasOptionSelected': hasOptionSelected,
      'id': id,
      'caseApplicationTeamId': caseApplicationTeamId,
      'rows': [],
      'renderRows': [],
      'isLabelLocked': false,
      'labelLinesCache': {},
      'teamData': undefined as any
    };
    return table;
  }

  ngOnInit() {
    console.log(`--- INITIALISE BUDGET TABLE ---\n//---// BPH CHANGE //---//\n${this.bphChange}`);
    this.originalValueForShowSaveNavBar = cloneDeep(this.showSaveNavBar);
    this.tableConfChange = this.confChange;
    this.widthDividerForDynamicWidth = this.confChange.subBlocks.length;
    if (this.confChange.paginationValues) {
      this.pageSizeOptions = this.confChange.paginationValues.split(',').map(e => Number(e));
      this.pageSize = this.pageSizeOptions[0];
    }

    this.bphChange.showDetails = false;

    // generate tables for each team if enabled in admin page
    this.generateBudgetTables();

    // Check and remove budget tables for deleted teams
    this.removeBudgetTablesForDeletedTeams();

    /**
     * Removes duplicate entries from the budget table.
     * A row is considered a duplicate if both 'teamData.VALUE' AND 'teamData.EMAIL'
     */
    this.removeBudgetTableDuplicates();

    // checking all sub-blocks for the key hasExpandRowsValues
    this.getTotalComps();

    // fix version compatibilities
    this.fixVersionsTotalComps();

    this.refreshDataService.getAllExpenditureItems(this.globalPrj.competitionIds[0]).subscribe((item) => {

      item = item.expenditureItems.filter(exp => {
        // Check for typeOfItems filter
        const typeOfItemsFilter = !this.confChange.typeOfItems || exp.budgetClassificationId === this.confChange.typeOfItems.id;
        // Check for budgetChartId filter
        const budgetChartIdFilter = !this.confChange.budgetChartId || exp.chartId === Number.parseInt(this.confChange.budgetChartId);
        // Return true only if both conditions are met
        return typeOfItemsFilter && budgetChartIdFilter;
      });

      this.globalPrj.categoryList = item.map((expenditure) => {
        expenditure.value = expenditure.childExpenditureId;
        expenditure.label = expenditure.childExpenditure;
        expenditure.children = expenditure.children.map((child) => {
          child.value = child.childExpenditureId;
          child.label = child.childExpenditure;
          return child;
        }).sort((a, b) => a.sortingKey > b.sortingKey);
        return expenditure;
      }).sort((a, b) => a.sortingKey > b.sortingKey);

      // Migrate data after loading expenditure items
      this.migrateExistingData();
    })

    if (this.confChange.readOnlyTable) {
      this.widthDividerForDynamicWidth = this.widthDividerForDynamicWidth + 1;
    }
    if (this.confChange.showDelete) {
      this.widthDividerForDynamicWidth = this.widthDividerForDynamicWidth + 1;
    }
    if (!this.confChange.tableLabel) {
      this.confChange.tableLabel = {};
    }
    if (!this.bphChange) {
      this.bphChange = {};
      this.bphChange.error = {};
      this.bphChange.rows = [];
      this.bphChange.renderRows = [];
    }

    if (!this.confChange.yearLabel) {
      this.confChange.yearLabel = { 'en': 'Year', 'fr': 'Année' };
    }

    if (!this.confChange.subtotalLabel) {
      this.confChange.subtotalLabel = { 'en': 'Total', 'fr': 'Total' }
    }

    if (!this.confChange.summaryTabelLabel) {
      this.confChange.summaryTabelLabel = { 'en': 'Summary table', 'fr': 'Sommaire' }
    }

    if (!this.confChange.numberOfYears || this.confChange.numberOfYears === 1) {
      this.confChange.numberOfYears = 1;
    }

    if (!this.bphChange.yearRows || this.bphChange.yearRows.length !== this.confChange.numberOfYears) {
      this.bphChange.yearRows = [];
      for (let i = 0; i < this.confChange.numberOfYears; i++) {
        this.bphChange.yearRows.push({
          'value': 0,
          'error': {}
        });
      }
    }

    if (!this.bphChange.error) {
      this.bphChange.error = {};
    }

    this.generateAndSortRowsToRender();
    this.generateSummaryTable();

    this.formValidationSubscription = this.refreshDataService.onFormValidation().subscribe((data) => {
      if (!data) return;

      console.log('Form validated');
      this.globalPrj = data;
      const section = this.globalPrj?.[this.selectedSectionId];

      // Utility: set `row.hasError` based on object-like fields containing errors
      const markRowsErrors = (rows?: any[]) => {
        if (!rows?.length) return;
        rows.forEach((row) => {
          // Inspect only object-valued fields that could carry error info
          const hasError = Object.keys(row)
            .filter((k) => row[k] !== null && typeof row[k] === 'object')
            .some((k) => {
              const f = row[k];
              const hasErrorObj = !!f?.error && Object.keys(f.error).length > 0;
              const hasErrorClass =
                typeof f?.error_class === 'string' && f.error_class.trim() !== '';
              return hasErrorObj || hasErrorClass;
            });

          row.hasError = hasError;
        });
      };

      const confBlock = section?.[this.confChange?.name];
      if (!confBlock?.budgetTables?.length) return;

      confBlock.budgetTables.forEach(table => {
        markRowsErrors(table?.rows);
      });
      this.bphChange = confBlock;

      this.generateAndSortRowsToRender();
      this.generateSummaryTable();
    });

    if (typeof this.confChange?.assignLabels === 'function') {
      this.confChange.assignLabels(
        this.globalPrj,
        this.bphChange
      );
    }

  }

  getTranslatedLabel(key: string) {
    return ECaseUtils.getTranslatedValueFromKey(this.translate, key, this.selectedLanguage);
  }

  getRange(value: number): number[] {
    return Array.from({ length: value }, (_, index) => index);
  }

  ngAfterViewInit() {
    this.confChange.subBlocks = this.confChange.subBlocks.map((subBlock) => {
      subBlock.templateName = subBlock.type;
      subBlock.templateContext = {
        'bphChange': this.bphChange,
        'confChange': subBlock,
        'isValidHtml': false,
        'isValidTable': !subBlock.readOnlyTable,
        'isValidTableReadonly': subBlock.readOnlyTable
      };
      subBlock.templateContext2 = {
        'bphChange': this.bphChange,
        'confChange': subBlock,
        'isValidHtml': true,
        'isValidTable': false,
        'isValidTableReadonly': false
      };
      return subBlock;
    });
  }

  executeFunction(confChange, bphChange, rowIndex) {
    if (confChange.updateOutputEventFunctions) {
      this.globalConf.http = this.eCaseHttpService;
      this.globalConf.teamTableIndex = this.teamTableIndex;
      for (const functionName of confChange.updateOutputEventFunctions) {
        if (confChange[functionName]) {
          confChange[functionName](bphChange.value, rowIndex, this.globalPrj, this.globalConf, this.selectedLanguage, this.refreshDataService);
        }
      }
    }

    // Handle category change
    if (confChange.name === 'select_category' && bphChange.value?.value) {
      const table = this.selectedTable;
      const row = table.renderRows[rowIndex];
      if (row) {
        this.onCategoryChange(row, bphChange.value.value);
      }
    }
  }


  doNothing() {
  }

  getAlignClass(): string {
    switch (this.confChange.totalTextAlign) {
      case 'start':
        return 'align-start';
      case 'end':
        return 'align-end';
      case undefined:
        return '';
    }
  }

  getTotalComps() {
    this.confChange.subBlocks.forEach(entity => {
      if (entity.hasExpandRowsValues) {
        this.confChange[entity.name].hideCellInDetailView = true;

        const minimalItem = {
          name: entity.name,
          label: entity.label || {},
          hasDialog: entity.hasDialog || false,
          onlyRevisionMode: entity.onlyRevisionMode || false,
          allowEmptyValues: entity.allowEmptyValues || false,
          removeFromSum: entity.removeFromSum || false
        };

        this.expRowCompArr.push({
          'item': minimalItem,
          'value': '',
          'error': {}
        });
        if (!entity.onlyRevisionMode || this.isFormRevisionMode) {
          this.expRowCompArrDetailExcludeRevision.push({
            'item': minimalItem,
            'value': '',
            'error': {}
          });
        }
      }
    });
  }

  addTableRow(blockData, blockConf, table, tableIndex) {
    console.log(`--- ADD ROW TO TABLE --- \nbphChange - ${blockData}\nconfChange - ${blockConf}\ntable - ${table}`);
    blockConf.isAddRowFunctionActive = true;
    blockConf.isEditRowFunctionActive = false;

    this.confChange = _.cloneDeep(blockConf);
    this.bphChange = _.cloneDeep(blockData);
    this.copyBlockData = _.cloneDeep(this.bphChange);
    if (!this.confChange.tableLabel) {
      this.bphChange.globalShowDetail = false;
    }
    if (blockConf.readOnlyTable) {
      this.refreshDataService.toggleShowSaveNavBar(false);
      ECaseUtils.scrollToTop('.content-wrapper');
    }
    // Keep the current state (to restore if we cancel the row edit)
    this.tempDocIds = _.cloneDeep(this.globalPrj.docsIds);
    this.tempUploadToBeDeleted = _.cloneDeep(this.globalPrj.upload_to_be_deleted);

    table.rows = table.rows || [];
    const aRow: any = {};
    aRow.uniqueRowIndex = table.rows.length > 0 ? (Math.max.apply(Math, table.rows.map(function (o) {
      return o.uniqueRowIndex ? o.uniqueRowIndex : 0;
    })) + 1) : 1;
    aRow.rowCode = ECaseUtils.generateHashCode(8);

    const globalArray = [];
    this.globalPrj = this.globalPrj ? this.globalPrj : _.cloneDeep(ECaseUtils.getCleanedJson(this.globalPrj, false));
    for (const x in this.globalPrj[this.selectedSectionId]) {
      if (x !== blockConf.name) {
        globalArray.push(x);
      }
    }

    blockConf.subBlocks.forEach(entity => {
      aRow[entity.name] = {};
      if (!blockConf[entity.name]) {
        blockConf[entity.name] = entity;
      }
      blockConf[entity.name].rowSpan = 1;

      if (entity.name === 'select_category') {
        aRow[entity.name].useGlobalList = true;
      } else if (entity.name === 'select_sub_category') {
        aRow[entity.name].useGlobalList = true;
        aRow[entity.name].disabled = true;
      }
    })

    // adding expand rows with quantity of years set in the admin
    aRow['expandRows'] = []
    if (this.confChange.numberOfYears) {
      for (let i = 0; i < this.confChange.numberOfYears; i++) {
        const yearLabelObject = cloneDeep(this.confChange.yearLabel);
        Object.keys(this.confChange.yearLabel).forEach((key) => {
          yearLabelObject[key] = this.confChange.yearLabel[key] + ' ' + (i + 1);
        });
        let expandRow: any = {
          'year': i + 1,
          'label': yearLabelObject,
          'subTotal': {
            'value': '',
            'error': {}
          },
          'totalComps': _.cloneDeep(this.expRowCompArr)
        };

        aRow.expandRows.push(expandRow);
      }
    }

    this.tempRow = aRow;
    // blockConf.total.hideCellInDetailView = !blockConf.hideYearsExpenditure;
    blockData.budgetTables[tableIndex].rows.push(aRow)
    blockData.budgetTables[tableIndex]['selectedRowIndex'] = blockData.budgetTables[tableIndex].rows - 1;
    this.selectedTable = table;
    this.selectedTableRowIndex = table.rows.length - 1;
    blockData.selectedRow = aRow;
    this.showAddEditTableForm = true;
    blockConf.showDetails = true;
    blockData.showDetails = true;
    this.globalConf.showDetails = true;

    if (blockConf.name != 'sub_table') {
      for (let k = 0; k < globalArray.length; k++) {
        try {
          ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).globalShowDetail = false;
          ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).showDetails = false;
          ((this.globalConf[this.selectedSectionId])[globalArray[k]]).showDetails = false;
        } catch (e) {
        }
      }
      if (this.confChange.selectedContainerName) {
        this.globalPrj[this.selectedSectionId][this.confChange.selectedContainerName].rows.forEach((row) => {
          if (row.sub_table) {
            row.sub_table.showDetails = false;
          }
        });
      }
    }

    if (blockConf.readOnlyTable) {
      blockConf.subBlocks.forEach(function (entity) {
        aRow[entity.name].globalShowDetail = true;
      });
      window.scrollTo(0, 0);
    }
    if (this.confChange.addRowFunction) {
      this.confChange.addRowFunction(this.globalPrj, this.globalConf, this, this.selectedLanguage, tableIndex);
    }
    this.bphChange = blockData;
    this.confChange = blockConf;
    this.pendingChangesGuard.isPristine = false;
    this.showAddEditTableForm = true;
    this.indexOfEditedRow = undefined;
  }

  getTotal(rows, column, j, tcolumn, row, currency, totalText, type, confChange) {
    if (totalText) {
      return totalText[this.selectedLanguage];
    } else {
      let r = 0;
      if ((typeof column !== 'undefined') && column !== '') {
        for (let i = j - 1; i >= 0; i--) {
          if (rows[i].isTotal && rows[i].column === tcolumn) {
            break;
          }
          if (!rows[i].isTotal) {
            let newCellVal = 0;
            if (rows[i][column] && type === 'Checkbox') {
              const arr = rows[i][column]['value'];
              newCellVal = arr.filter(item => item.value === true).length;
            } else if (rows[i][column] && !isNaN(parseInt(rows[i][column]['value'], 10))) {
              newCellVal = parseFloat(rows[i][column]['value']);
            }
            r = r + newCellVal;
          }
          if (row) {
            if (!row[column]) {
              row[column] = {};
            }
            row[column]['value'] = r;
          }
        }
        row[column]['value'] = Math.round(r * 100) / 100;
      } else {
        r = null;
      }
      let currencySign = '0,0$';
      if (!currency) {
        currencySign = '';
      }
      return this.eCaseNumberFormatterPipe.transform(r, currency, null, this.selectedLanguage, null, confChange.decimalPlacesAllowed);
    }
  }

  mathFloor(number) {
    return Math.floor(number);
  }

  parseInt(number) {
    return parseInt(number, 10);
  }

  multiYearRowIndexCalculator(rowIndex, noOfYears) {
    noOfYears = isNaN(noOfYears) ? 1 : noOfYears;
    return rowIndex % (noOfYears + 1);
  }

  getHeaderRowIndex(rowIndex, noOfYears) {
    noOfYears = isNaN(noOfYears) ? 1 : noOfYears;
    return (noOfYears + 1) * (Math.floor(rowIndex / (noOfYears + 1)));
  }

  cleanErrors(blockData) {
    for (var key in blockData.selectedRow) {
      if (blockData.selectedRow.hasOwnProperty(key) && blockData.selectedRow[key] && blockData.selectedRow[key].hasOwnProperty('error')) {
        blockData.selectedRow[key].error = {};
      }
    }
  }

  closeDetails(blockConf, blockData) {

    console.log('//---// SAVE BUTTON BUDGET TABLE ROW DETAIL PRESSED //---//');
    console.log(blockConf);
    console.log(blockData);

    this.migrateExistingData();

    this.refreshDataService.tableCancelClicked(this.globalPrj);

    this.cleanErrors(blockData);
    let isRowValid = true;
    for (var key in blockData.selectedRow) {
      if (blockData.selectedRow.hasOwnProperty(key) &&
        blockData.selectedRow[key] &&
        blockData.selectedRow[key].hasOwnProperty('error')
      ) {
        if (blockConf[key] &&
          blockConf[key].isRequired &&
          !blockConf[key].hasExpandRowsValues) {
          const objError = {
            en: 'This field is required',
            fr: 'Ce champ est obligatoire'
          };
          let componentType = blockConf[key].templateName;
          let componentPath = blockData.selectedRow[key].value;
          if (componentType === "checkbox" || componentType.includes("checkbox")) {
            componentType = "checkbox";
            if (componentPath.filter(item => item.value === true).length === 0) {
              blockData.selectedRow[key].error = objError;
              isRowValid = false;
            }
          } else if (componentType === "upload" || componentType.includes("upload")) {
            if (componentPath.length === 0) {
              isRowValid = false;
              blockData.selectedRow[key].error = objError;
            }
          } else if (componentType !== "text" && componentType !== "textarea") {
            componentPath = componentPath.value;
          }

          if (componentType !== "checkbox" &&
            componentType !== "upload" &&
            componentType !== "statictext" &&
            (!componentPath || componentPath === null || componentPath === "")) {
            blockData.selectedRow[key].error = objError;
            isRowValid = false;
          }
        }
      }
    }

    blockData.selectedRow.expandRows.forEach(expandRow => {
      expandRow.totalComps.forEach(comp => {
        if ((comp.value === "" || comp.value === null || comp.value === undefined) && !comp.item.onlyRevisionMode) {
          comp.error = {
            en: 'This field is required',
            fr: 'Ce champ est obligatoire'
          };
          isRowValid = false;
        } else {
          comp.error = {};
        }
      });
    });

    if (!isRowValid) {
      return;
    }

    blockConf.showDetails = false;
    blockData.showDetails = false;
    this.globalConf.showDetails = false;

    if (this.confChange.hideYearsExpenditure) {
      blockData.budgetTables.forEach(table => {
        table.rows.forEach(row => {
          row.expandRows[0].subTotal.value = Number(row.total.value) || 0;
          row.total.value = Number(row.total.value) || 0;
          row.expandRows.forEach(innerRow => {
            innerRow.totalComps.forEach(comp => {
              if (row?.[comp.item.name]) {
                row[comp.item.name].value = Number.isNaN(Number(comp.value))
                  ? (comp.item.allowEmptyValues ? "" : 0)
                  : Number(comp.value);
              } else {
                row[comp.item.name] = {
                  'value': Number.isNaN(Number(comp.value))
                    ? (comp.item.allowEmptyValues ? "" : 0)
                    : Number(comp.value),
                  "globalShowDetail": true,
                  "error": {},
                  "error_class": ""
                }
              }
            })
          })

        })
      })
    }

    const globalArray = [];
    for (const x in this.globalPrj[this.selectedSectionId]) {
      if (x !== blockConf.name) {
        globalArray.push(x);
      }
    }
    for (let k = 0; k < globalArray.length; k++) {
      try {
        ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).globalShowDetail = true;
        ((this.globalConf[this.selectedSectionId])[globalArray[k]]).showDetails = false;
        ((this.globalConf[this.selectedSectionId])[globalArray[k]]).showDetails = false;
      } catch (e) {
      }
    }

    if (blockConf.isAddRowFunctionActive && blockConf.addRow) {
      blockConf.addRow(this.globalPrj, this.globalConf, this, this.selectedLanguage, blockData);
    }
    if (blockConf.isEditRowFunctionActive) {
      if (typeof blockConf.editRow === 'function') {
        console.log('//---// EDIT ROW FUNCTION IS ACTIVE //---//');
        blockConf.editRow(this.globalPrj, this.globalConf, this, this.selectedTableRowIndex, blockData);
      }
    }
    if (blockConf.isAfterSaveFunctionActive) {
      if (typeof blockConf.afterSaveFunction === 'function') {
        blockConf.afterSaveFunction(this.globalPrj, this.globalConf, this, this.selectedTableRowIndex, blockData);
      }
    }

    if (this.originalValueForShowSaveNavBar) {
      this.refreshDataService.toggleShowSaveNavBar(true);
    }

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()

    if (typeof blockConf.lastSaveFunction === 'function') {
      console.log('//---// LAST FUNCTION CALLED //---//');
      blockConf.lastSaveFunction(this.globalPrj, this.globalConf, this, this.selectedTableRowIndex, blockData);
    }

    if (typeof blockConf.saveBudgetToDb === 'function') {
      blockConf.saveBudgetToDb(this.globalPrj, this.globalConf, this, this.selectedTableRowIndex, blockData);
    } else {
      this.saveBudgetToDb(blockData);
    }

    this.refreshDataService.saveForm({
      operation: 'Save',
      prj: this.globalPrj,
      isHideSnackBar: true
    });

    this.refreshDataService.toggleShowSaveNavBar(true);
    this.showAddEditTableForm = false;
  }

  getTotalDynamic(rows, column, j, dynaIndex, row, currency, totalText) {
    if (totalText) {
      return totalText[this.selectedLanguage];
    } else {
      let r = 0;
      if ((typeof column !== 'undefined') && column !== '') {
        let tcolumn;
        for (let i = j - 1; i >= 0; i--) {
          if (rows[i].isTotal && rows[i].column === tcolumn) {
            break;
          }
          if (!rows[i].isTotal) {
            let newCellVal = 0;
            if (rows[i][column] && !isNaN(parseInt(rows[i][column]['value'][dynaIndex], 10))) {
              newCellVal = Math.round(parseFloat(rows[i][column]['value'][dynaIndex]) * 100) / 100;
            }
            r = r + newCellVal;
          }
          if (row) {
            if (!row[column]) {
              row[column] = {};
            }
            row[column]['value'] = r;
          }
        }
      } else {
        r = null;
      }
      let currencySign = '0,0$';
      if (!currency) {
        currencySign = '';
      }
      return currencySign;
    }
  }

  editRow(blockData, blockConf, index, tableIndex) {
    console.log('//---// EDIT ROW //---//');
    blockConf.isAddRowFunctionActive = false;
    blockConf.isEditRowFunctionActive = true;
    this.selectedTableRowIndex = index;
    this.selectedTable = blockData.budgetTables[tableIndex];
    this.showAddEditTableForm = true;
    this.copyBlockData = _.cloneDeep(this.bphChange);
    if (blockConf.type === 'SchedulerTable') {
      blockData.rowsForSchedulerTable[index].rowIndex = index;
      blockData.selectedRowIndex = index;
    }
    this.globalPrj.isConfirmationSaved = false;
    // Keep the current state (to restore if we cancel the row edit)
    this.tempDocIds = _.cloneDeep(this.globalPrj.docsIds);
    this.tempUploadToBeDeleted = _.cloneDeep(this.globalPrj.upload_to_be_deleted);
    if (blockConf.readOnlyTable) {
      this.refreshDataService.toggleShowSaveNavBar(false);
    }

    this.tempRow = blockData.budgetTables[tableIndex].rows[index];
    blockData.selectedRow = blockData.budgetTables[tableIndex].rows[index];
    blockConf.showDetails = true;
    blockData.showDetails = true;
    this.globalConf.showDetails = true;
    const globalArray = [];
    for (const x in this.globalPrj[this.selectedSectionId]) {
      if (x !== blockConf.name) {
        globalArray.push(x);
      }
    }
    if (blockConf.name !== 'sub_table' || blockConf.isolateSectionOnEdit) {
      for (let k = 0; k < globalArray.length; k++) {
        try {
          ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).globalShowDetail = false;
          ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).showDetails = false;
          ((this.globalConf[this.selectedSectionId])[globalArray[k]]).showDetails = false;
        } catch (e) {
        }
      }
      if (this.confChange.selectedContainerName && this.confChange.selectedContainerName.split('.')[0]) {
        this.globalPrj[this.selectedSectionId][this.confChange.selectedContainerName].rows.forEach((row) => {
          if (row.sub_table) {
            row.sub_table.showDetails = false;
          }
        });
        this.bphChange.showDetails = true;
      }
    }

    let checkComp: boolean;
    let unexistendCompsArr = [];
    this.tempRow.expandRows.forEach((row: any) => {
      this.expRowCompArr.forEach((obj: any) => {
        checkComp = row.totalComps.find(item => item.item.name === obj.item.name);
        if (!checkComp) {
          unexistendCompsArr.push(_.cloneDeep(obj));
        }
      })
      row.totalComps = row.totalComps.concat(unexistendCompsArr);
      unexistendCompsArr = [];
    });

    blockData['selectedRowIndex'] = index;
    if (this.confChange.editRowFunction) {
      this.confChange.editRowFunction(this.globalPrj, this.globalConf, this, this.selectedLanguage);
    }

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()
    // this.copyBlockData = _.cloneDeep(this.bphChange);
    window.scrollTo(0, 0);
  }

  orderTableBycolumn(blockData, blockConf, column) {
    if (blockConf && blockConf.showOrderBy) {
      blockData.rows = _.filter(blockData.rows, function (e) {
        return !e.isTotal;
      });
      blockData.rows = _.orderBy(blockData.rows, column);
    }
  }

  orderTable(blockData, blockConf) {
    if (blockConf && blockConf.showOrderBy) {
      blockData.rows = _.filter(blockData.rows, function (e) {
        return !e.isTotal;
      });
      const groupByColumns = blockConf.orderedBy.split(',');
      if (blockConf.orderedByTypes) {
        const groupByTypes = blockConf.orderedByTypes.split(',');
        blockData.rows = _.orderBy(blockData.rows, groupByColumns, groupByTypes);
      } else {
        blockData.rows = _.orderBy(blockData.rows, groupByColumns);
      }
    }
  }

  createArrayOfLength(n): any[] {
    return Array.from(Array(n).keys());
  }

  filterHideCellSubBlocks(subBlocks: any[]): any[] {
    return subBlocks.filter(e => !e.hideCell);
  }

  generateAndSortRowsToRender() {
    this.bphChange.budgetTables.forEach(table => {
      if (table.rows?.length) {
        this.sortRowsToRender(table);
      } else {
        table.renderRows = [];
      }
    })
  }

  // Function to sort rows by Categories and Sub categories
  sortRowsToRender(table) {
    // Filtering rows to get only unique rows which has information to sort
    let rows = table.rows.filter(item => item.uniqueRowIndex)
    // Sorting the array by select_category.value.value and select_sub_category.value.value
    rows.sort((a, b) => {
      const categoryComparison = a.select_category.value.value - b.select_category.value.value;
      if (categoryComparison !== 0) {
        return categoryComparison;
      }

      return a.select_sub_category.value.value - b.select_sub_category.value.value;
    });
    table.rows = rows;
    const result = [];
    let currentCategory = null;
    let currentSubCategory = null;
    let currCatSum = 0;
    let currSubCatSum = 0;
    let grandTotalSum = 0;
    let tmpSubCatObj;
    let tmpCatObj;

    // Initialize year rows for tracking sums by year
    const numberOfYears = this.confChange.numberOfYears || 1;
    let currSubCatYearRows = [];
    let currCatYearRows = [];
    let grandTotalYearRows = [];

    // Get fields with hasExpandRowsValues for totalComps structure
    const expandRowsFields = this.confChange.subBlocks.filter(obj => obj.hasExpandRowsValues);
    // Also include "total" field if it exists, even if it doesn't have hasExpandRowsValues
    const totalField = this.confChange.subBlocks.find(obj => obj.name === 'total');
    const allFieldsForTotalComps = totalField && !expandRowsFields.find(f => f.name === 'total')
      ? [...expandRowsFields, totalField]
      : expandRowsFields;

    // Initialize year rows with totalComps structure
    for (let i = 0; i < numberOfYears; i++) {
      const subCatYearRow = { value: 0, error: {}, totalComps: [] };
      const catYearRow = { value: 0, error: {}, totalComps: [] };
      const grandTotalYearRow = { value: 0, error: {}, totalComps: [] };

      allFieldsForTotalComps.forEach(field => {
        const minimalItem = {
          name: field.name,
          label: field.label || {},
          hasDialog: field.hasDialog || false,
          onlyRevisionMode: field.onlyRevisionMode || false,
          allowEmptyValues: field.allowEmptyValues || false,
          removeFromSum: field.removeFromSum || false
        };

        subCatYearRow.totalComps.push({
          item: minimalItem,
          value: 0,
          error: {}
        });
        catYearRow.totalComps.push({
          item: minimalItem,
          value: 0,
          error: {}
        });
        grandTotalYearRow.totalComps.push({
          item: minimalItem,
          value: 0,
          error: {}
        });
      });

      currSubCatYearRows.push(subCatYearRow);
      currCatYearRows.push(catYearRow);
      grandTotalYearRows.push(grandTotalYearRow);
    }

    let subTotals = [];

    this.confChange.subBlocks.forEach(obj => {
      if (obj.hasBudgetSubTotal || obj.hasExpandRowsValues) {
        subTotals.push({
          name: obj.name,
          currency: obj.currency,
          currCatSum: 0,
          currSubCatSum: 0,
          grandTotalSum: 0
        })
      }
    })

    for (const [index, item] of rows.entries()) {
      // Ensure data rows are clean from subtotal/visibility flags that belong only to generated total rows
      if (item && item.isSubCategoryTotal === true) {
        delete item.isSubCategoryTotal;
      }
      if (item && item.isHidden === true) {
        delete item.isHidden;
      }
      if (currentSubCategory !== item.select_sub_category.value.value) {
        // Add a new object for the sub-category sum (skip for the first iteration)
        if (currentSubCategory !== null) {
          tmpSubCatObj = {
            isHidden: !this.confChange.showSubCategoriesTotal,
            isSubCategoryTotal: true,
            subCategoryId: currentSubCategory,
            label: {
              'en': 'Sub Category sub-total',
              'fr': 'Sous-catégorie Sous-total'
            },
            value: {
              error: {},
              value: currSubCatSum
            },
            expandRows: currSubCatYearRows.map((yearRow, index) => {
              // Get value from totalComps where item.name == 'total' for subTotal
              const totalComp = yearRow.totalComps?.find(comp => comp.item?.name === 'total');
              const subTotalValue = totalComp ? totalComp.value : yearRow.value;

              return {
                year: index + 1,
                label: {
                  'en': `${this.confChange.yearLabel?.en || 'Year'} ${index + 1}`,
                  'fr': `${this.confChange.yearLabel?.fr || 'Année'} ${index + 1}`
                },
                subTotal: {
                  value: subTotalValue,
                  error: {}
                },
                totalComps: yearRow.totalComps ? yearRow.totalComps.map(comp => ({
                  item: comp.item,
                  value: comp.value,
                  error: comp.error || {}
                })) : []
              };
            })
          }
          subTotals.forEach(sub => {
            tmpSubCatObj[sub.name] = {
              value: sub.currSubCatSum,
              currency: sub.currency
            }
            sub.currSubCatSum = Number(item?.[sub.name]?.value) || 0;
          })
          result.push(tmpSubCatObj);
        }

        subTotals.forEach(sub => {
          sub.currSubCatSum = Number(item?.[sub.name]?.value) || 0;
        })
        // Reset year rows for new sub-category
        currSubCatYearRows = [];
        for (let i = 0; i < numberOfYears; i++) {
          const yearRow = { value: 0, error: {}, totalComps: [] };
          allFieldsForTotalComps.forEach(field => {
            const minimalItem = {
              name: field.name,
              label: field.label || {},
              hasDialog: field.hasDialog || false,
              onlyRevisionMode: field.onlyRevisionMode || false,
              allowEmptyValues: field.allowEmptyValues || false,
              removeFromSum: field.removeFromSum || false
            };
            yearRow.totalComps.push({
              item: minimalItem,
              value: 0,
              error: {}
            });
          });
          currSubCatYearRows.push(yearRow);
        }
        // Update current sub-category and reset sum
        currentSubCategory = item.select_sub_category.value.value;
        currSubCatSum = item.total.value || 0;

        // Initialize sums for the new sub-category from current item
        if (item.expandRows && item.expandRows.length > 0) {
          item.expandRows.forEach((expandRow, yearIndex) => {
            if (yearIndex < currSubCatYearRows.length) {
              // Get value from totalComps where item.name == 'total', not from subTotal
              const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
              const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
              currSubCatYearRows[yearIndex].value = yearValue;

              // Initialize totalComps values for fields with hasExpandRowsValues
              if (expandRow.totalComps && expandRow.totalComps.length > 0) {
                expandRow.totalComps.forEach((comp) => {
                  const matchingComp = currSubCatYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
                  if (matchingComp) {
                    const compValue = Number(comp.value) || 0;
                    matchingComp.value = compValue;
                  }
                });
              }
            }
          });
        }
      } else {
        subTotals.forEach(sub => {
          sub.currSubCatSum += Number(item?.[sub.name]?.value) || 0;
        })
        currSubCatSum += item.total.value || 0;

        // Accumulate year sums for the same sub-category
        if (item.expandRows && item.expandRows.length > 0) {
          item.expandRows.forEach((expandRow, yearIndex) => {
            if (yearIndex < currSubCatYearRows.length) {
              // Get value from totalComps where item.name == 'total', not from subTotal
              const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
              const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
              currSubCatYearRows[yearIndex].value += yearValue;

              // Accumulate totalComps values for fields with hasExpandRowsValues
              if (expandRow.totalComps && expandRow.totalComps.length > 0) {
                expandRow.totalComps.forEach((comp) => {
                  const matchingComp = currSubCatYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
                  if (matchingComp) {
                    const compValue = Number(comp.value) || 0;
                    matchingComp.value += compValue;
                  }
                });
              }
            }
          });
        }
      }

      if (currentCategory !== item.select_category.value.value) {
        // Add a new object for the category sum (skip for the first iteration)
        if (currentCategory !== null) {
          tmpCatObj = {
            isHidden: !this.confChange.showCategoriesTotal,
            isCategoryTotal: true,
            categoryId: currentCategory,
            label: {
              'en': 'Category sub-total',
              'fr': 'Sous-total de la catégorie'
            },
            value: {
              error: {},
              value: currCatSum
            },
            expandRows: currCatYearRows.map((yearRow, index) => {
              // Get value from totalComps where item.name == 'total' for subTotal
              const totalComp = yearRow.totalComps?.find(comp => comp.item?.name === 'total');
              const subTotalValue = totalComp ? totalComp.value : yearRow.value;

              return {
                year: index + 1,
                label: {
                  'en': `${this.confChange.yearLabel?.en || 'Year'} ${index + 1}`,
                  'fr': `${this.confChange.yearLabel?.fr || 'Année'} ${index + 1}`
                },
                subTotal: {
                  value: subTotalValue,
                  error: {}
                },
                totalComps: yearRow.totalComps ? yearRow.totalComps.map(comp => ({
                  item: comp.item,
                  value: comp.value,
                  error: comp.error || {}
                })) : []
              };
            })
          }
          subTotals.forEach(cat => {
            tmpCatObj[cat.name] = {
              value: cat.currCatSum,
              currency: cat.currency
            }
            cat.grandTotalSum += cat.currCatSum;
            cat.currCatSum = Number(item?.[cat.name]?.value) || 0;
          })
          result.push(tmpCatObj);
          grandTotalSum += currCatSum;

          // Accumulate year sums for grand total from category totals
          if (tmpCatObj.expandRows && tmpCatObj.expandRows.length > 0) {
            tmpCatObj.expandRows.forEach((expandRow, yearIndex) => {
              if (yearIndex < grandTotalYearRows.length) {
                // Get value from totalComps where item.name == 'total', not from subTotal
                const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
                const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
                grandTotalYearRows[yearIndex].value += yearValue;

                // Accumulate totalComps values for fields with hasExpandRowsValues
                if (expandRow.totalComps && expandRow.totalComps.length > 0) {
                  expandRow.totalComps.forEach((comp) => {
                    const matchingComp = grandTotalYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
                    if (matchingComp) {
                      const compValue = Number(comp.value) || 0;
                      matchingComp.value += compValue;
                    }
                  });
                }
              }
            });
          }
        }
        subTotals.forEach(cat => {
          cat.currCatSum = Number(item?.[cat.name]?.value) || 0;
        })
        // Reset year rows for new category
        currCatYearRows = [];
        for (let i = 0; i < numberOfYears; i++) {
          const yearRow = { value: 0, error: {}, totalComps: [] };
          allFieldsForTotalComps.forEach(field => {
            const minimalItem = {
              name: field.name,
              label: field.label || {},
              hasDialog: field.hasDialog || false,
              onlyRevisionMode: field.onlyRevisionMode || false,
              allowEmptyValues: field.allowEmptyValues || false,
              removeFromSum: field.removeFromSum || false
            };
            yearRow.totalComps.push({
              item: minimalItem,
              value: 0,
              error: {}
            });
          });
          currCatYearRows.push(yearRow);
        }
        // Update current category and reset sum
        currentCategory = item.select_category.value.value;
        currCatSum = item.total.value || 0;

        // Initialize sums for the new category from current item
        if (item.expandRows && item.expandRows.length > 0) {
          item.expandRows.forEach((expandRow, yearIndex) => {
            if (yearIndex < currCatYearRows.length) {
              // Get value from totalComps where item.name == 'total', not from subTotal
              const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
              const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
              currCatYearRows[yearIndex].value = yearValue;

              // Initialize totalComps values for fields with hasExpandRowsValues
              if (expandRow.totalComps && expandRow.totalComps.length > 0) {
                expandRow.totalComps.forEach((comp) => {
                  const matchingComp = currCatYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
                  if (matchingComp) {
                    const compValue = Number(comp.value) || 0;
                    matchingComp.value = compValue;
                  }
                });
              }
            }
          });
        }
      } else {
        subTotals.forEach(cat => {
          cat.currCatSum += Number(item?.[cat.name]?.value) || 0;
        })
        currCatSum += item.total.value || 0;

        // Accumulate year sums for the same category
        if (item.expandRows && item.expandRows.length > 0) {
          item.expandRows.forEach((expandRow, yearIndex) => {
            if (yearIndex < currCatYearRows.length) {
              // Get value from totalComps where item.name == 'total', not from subTotal
              const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
              const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
              currCatYearRows[yearIndex].value += yearValue;

              // Accumulate totalComps values for fields with hasExpandRowsValues
              if (expandRow.totalComps && expandRow.totalComps.length > 0) {
                expandRow.totalComps.forEach((comp) => {
                  const matchingComp = currCatYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
                  if (matchingComp) {
                    const compValue = Number(comp.value) || 0;
                    matchingComp.value += compValue;
                  }
                });
              }
            }
          });
        }
      }

      // Add the original item
      item['renderPosition'] = index;
      result.push(item);
    }

    // Add the last sub-category and category sums
    tmpSubCatObj = {
      isHidden: !this.confChange.showSubCategoriesTotal,
      isSubCategoryTotal: true,
      subCategoryId: currentSubCategory,
      label: {
        'en': 'Sub Category sub-total',
        'fr': 'Sous-catégorie Sous-total'
      },
      value: {
        error: {},
        value: currSubCatSum
      },
      expandRows: currSubCatYearRows.map((yearRow, index) => ({
        year: index + 1,
        label: {
          'en': `${this.confChange.yearLabel?.en || 'Year'} ${index + 1}`,
          'fr': `${this.confChange.yearLabel?.fr || 'Année'} ${index + 1}`
        },
        subTotal: {
          value: yearRow.value,
          error: {}
        },
        totalComps: yearRow.totalComps ? yearRow.totalComps.map(comp => ({
          item: comp.item,
          value: comp.value,
          error: comp.error || {}
        })) : []
      }))
    }
    subTotals.forEach(sub => {
      tmpSubCatObj[sub.name] = {
        value: sub.currSubCatSum,
        currency: sub.currency
      }
    })
    result.push(tmpSubCatObj);
    tmpCatObj = {
      isHidden: !this.confChange.showCategoriesTotal,
      isCategoryTotal: true,
      categoryId: currentCategory,
      label: {
        'en': 'Category sub-total',
        'fr': 'Sous-total de la catégorie'
      },
      value: {
        error: {},
        value: currCatSum
      },
      expandRows: currCatYearRows.map((yearRow, index) => ({
        year: index + 1,
        label: {
          'en': `${this.confChange.yearLabel?.en || 'Year'} ${index + 1}`,
          'fr': `${this.confChange.yearLabel?.fr || 'Année'} ${index + 1}`
        },
        subTotal: {
          value: yearRow.value,
          error: {}
        },
        totalComps: yearRow.totalComps ? yearRow.totalComps.map(comp => ({
          item: comp.item,
          value: comp.value,
          error: comp.error || {}
        })) : []
      }))
    }
    subTotals.forEach(sub => {
      tmpCatObj[sub.name] = {
        value: sub.currCatSum,
        currency: sub.currency
      }
    })
    result.push(tmpCatObj);

    // Accumulate year sums for grand total from last category totals
    if (tmpCatObj.expandRows && tmpCatObj.expandRows.length > 0) {
      tmpCatObj.expandRows.forEach((expandRow, yearIndex) => {
        if (yearIndex < grandTotalYearRows.length) {
          // Get value from totalComps where item.name == 'total', not from subTotal
          const totalComp = expandRow.totalComps?.find(comp => comp.item?.name === 'total');
          const yearValue = Number(totalComp?.value || expandRow.subTotal?.value || 0);
          grandTotalYearRows[yearIndex].value += yearValue;

          // Accumulate totalComps values for fields with hasExpandRowsValues
          if (expandRow.totalComps && expandRow.totalComps.length > 0) {
            expandRow.totalComps.forEach((comp) => {
              const matchingComp = grandTotalYearRows[yearIndex].totalComps.find(c => c.item.name === comp.item?.name);
              if (matchingComp) {
                const compValue = Number(comp.value) || 0;
                matchingComp.value += compValue;
              }
            });
          }
        }
      });
    }

    let grandTotalObj = {
      isTotal: true,
      label: {
        'en': 'Total',
        'fr': 'Total'
      },
      value: {
        error: {},
        value: grandTotalSum + currCatSum
      },
      expandRows: grandTotalYearRows.map((yearRow, index) => {
        // Get value from totalComps where item.name == 'total' for subTotal
        const totalComp = yearRow.totalComps?.find(comp => comp.item?.name === 'total');
        const subTotalValue = totalComp ? totalComp.value : yearRow.value;

        return {
          year: index + 1,
          label: {
            'en': `${this.confChange.yearLabel?.en || 'Year'} ${index + 1}`,
            'fr': `${this.confChange.yearLabel?.fr || 'Année'} ${index + 1}`
          },
          subTotal: {
            value: subTotalValue,
            error: {}
          },
          totalComps: yearRow.totalComps ? yearRow.totalComps.map(comp => ({
            item: comp.item,
            value: comp.value,
            error: comp.error || {}
          })) : []
        };
      })
    }
    subTotals.forEach(sub => {
      grandTotalObj[sub.name] = {
        value: (sub.grandTotalSum + sub.currCatSum),
        currency: sub.currency
      }
    })
    result.push(grandTotalObj)
    table.teamTotalAmount = grandTotalObj.value?.value || 0;
    table.renderRows = result;
  }

  reshuffleTable(blockData, blockConf) {
    if (blockConf && blockConf.showGroupBy) {
      blockData.rows = _.filter(blockData.rows, function (e) {
        return !e.isTotal;
      });
      if (blockData.rows.length === 0) {
        return;
      }
      const groupByColumns = blockConf.groupedBy.split(',');
      blockData.rows = _.orderBy(blockData.rows, groupByColumns);
      for (let i = groupByColumns.length - 1; i >= 0; i--) {
        if (i - 1 >= 0) {
          this.reshuffleColumn(blockData, blockConf, groupByColumns[i], i, groupByColumns[i - 1]);
        } else {
          this.reshuffleColumn(blockData, blockConf, groupByColumns[i], i, undefined);
        }
      }
    }
  }

  getValueForFbSelectSubBlock(currentValue, lang) {
    if (currentValue.value && currentValue.value.value >= ECaseUtilsGlobal.OTHER_VALUE_TERM_ID) {
      return currentValue.otherValue;
    } else {
      if (currentValue.value && currentValue.value.label) {
        return currentValue.value.label[lang];
      } else {
        return '';
      }
    }
  }

  getOtherValueForFbSelectSubBlock(currentValue) {
    return currentValue.otherValue;
  }

  reshuffleColumn(blockData, blockConf, gbcolumn, k, gPreviouscolumn) {
    let oldCol = 0;
    const indexes = [];
    const groupColumn = gbcolumn.split('.')[0];
    if (gPreviouscolumn) {
      eval('oldCol = blockData.rows[0].' + gbcolumn + ' +\'_\' +blockData.rows[0].' + gPreviouscolumn);
    } else {
      eval('oldCol = blockData.rows[0].' + gbcolumn);
    }
    /* Ignore tslint error: "ESLint: 'rowSpanRow' is never reassigned, use 'const' instead."
    It is being reassigned on line #552. Changing to const will cause errors in the form */
    let rowSpanRow: any = {};
    eval('rowSpanRow = blockData.rows[0].' + groupColumn);
    rowSpanRow.rowspan = 0;
    let newCol;
    for (let i = 0; i < blockData.rows.length; i++) {
      if (!blockData.rows[i].isTotal) {
        if (gPreviouscolumn) {
          eval('newCol = blockData.rows[i].' + gbcolumn + ' +\'_\' +blockData.rows[i].' + gPreviouscolumn);
        } else {
          eval('newCol = blockData.rows[i].' + gbcolumn);
        }
        console.log('groupColumn');
        console.log(groupColumn);
        if (oldCol !== newCol) {
          eval('blockData.rows[i].' + groupColumn + '.hideCell=false');
          indexes.push(i);
          oldCol = newCol;
          eval('rowSpanRow = blockData.rows[i].' + groupColumn);
          rowSpanRow.rowspan = 1;
        } else {
          eval('blockData.rows[i].' + groupColumn + '.hideCell=true');
          rowSpanRow.rowspan++;
        }
      } else {
        rowSpanRow.rowspan++;
      }
    }
    eval('blockData.rows[0].' + groupColumn + '.hideCell=false');
    indexes.push(blockData.rows.length + 1);
    let moved = 0;
    for (let i = 0; i < blockConf.subBlocks.length; i++) {
      if (blockConf.subBlocks[i].name === groupColumn && !blockConf.subBlocks[i].noSubTotal) {
        for (let i = 0; i < indexes.length; i++) {
          blockData.rows.splice(indexes[i] + moved, 0, { 'isTotal': true, 'position': k, 'column': groupColumn });
          moved++;
        }
      }
    }
  }

  handleEnterKey(event, confChange) {
    if (!confChange.readOnlyTable) {
      event.preventDefault();
    }
  }

  deleteRow(blockData, blockConf, index, tableIndex) {
    console.log(`//---// DELETE ROW ${index} IN TABLE ${tableIndex} //---//`);
    if (blockConf.isConfirmDelete) {
      if (typeof blockConf.confirmDelete === 'function') {
        if (blockConf.subBlocks) {
          for (let ii = 0; ii < blockConf.subBlocks.length; ii++) {
            if (blockConf.subBlocks[ii] && blockConf.subBlocks[ii].type === 'upload') {
              const subBlockName = blockConf.subBlocks[ii].name;
              if (blockData.budgetTables[tableIndex].rows[index][subBlockName].value) {
                for (let iiTobd = 0; iiTobd < blockData.budgetTables[tableIndex].rows[index][subBlockName].value.length; iiTobd++) {
                  if (blockData.budgetTables[tableIndex].rows[index][subBlockName].value[iiTobd] && blockData.budgetTables[tableIndex].rows[index][subBlockName].value[iiTobd].fileUploaded) {
                    if (!this.globalPrj.upload_to_be_deleted) {
                      this.globalPrj.upload_to_be_deleted = [];
                    }
                    this.globalPrj.upload_to_be_deleted.push(blockData.budgetTables[tableIndex].rows[index][subBlockName].value[iiTobd].id);
                  }
                }
              }
            }
          }
        }
        blockConf.confirmDelete(this.globalPrj, this.globalConf, this.matDialog, this.translate, index, this, this.dialogService);
      } else {
        if (this.confChange.isConfirmDeleteText) {
          const confirmDialogRef = this.matDialog.open(ECaseConfirmDialogComponent, {
            width: '700px',
          });
          const instance = confirmDialogRef.componentInstance;
          instance.confirmMessage = this.confChange.isConfirmDeleteText[this.selectedLanguage];
          confirmDialogRef.afterClosed().subscribe((decision) => {
            if (decision) {
              const deletedRow = _.cloneDeep(blockData.budgetTables[tableIndex].rows[index]);
              this.deleteTableRow(blockData, blockConf, index, tableIndex);
              if (this.confChange.deleteRowFunction) {
                this.confChange.deleteRowFunction(this.globalPrj, this.globalConf, index, this, this.selectedLanguage, deletedRow);
              }
            }
          });
        }
      }
    } else {
      const deletedRow = _.cloneDeep(blockData.budgetTables[tableIndex].rows[index]);
      this.deleteTableRow(blockData, blockConf, index, tableIndex);
      if (this.confChange.deleteRowFunction) {
        this.confChange.deleteRowFunction(this.globalPrj, this.globalConf, index, this, this.selectedLanguage, deletedRow);
      }
    }

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()
  }

  // Do not delete, used in block js of some tables.
  deleteMultiYearRow(i, blockData, blockConf) {
    blockData.noOfYears = blockData.noOfYears ? blockData.noOfYears : blockConf.noOfYears;
    const noOfYears = isNaN(parseInt(blockData.noOfYears, 10)) ? 1 : parseInt(blockData.noOfYears, 10);
    const rowModulesIndex = (i % (noOfYears + 1)).toString();
    if (blockConf.subBlocks) {
      for (let ii = 0; ii < blockConf.subBlocks.length; ii++) {
        if (blockConf.subBlocks[ii] && blockConf.subBlocks[ii].type === 'upload') {
          const subBlockName = blockConf.subBlocks[ii].name;
          if (((blockData.rows[i])[rowModulesIndex + ii.toString()])[subBlockName]?.value) {
            for (let iiTobd = 0; iiTobd < blockData.rows[i][rowModulesIndex + ii.toString()][subBlockName].value.length; iiTobd++) {
              if (((blockData.rows[i])[rowModulesIndex + ii.toString()])[subBlockName].value[iiTobd] && ((blockData.rows[i])[rowModulesIndex + ii.toString()])[subBlockName].value[iiTobd].fileUploaded) {
                if (!this.globalPrj.upload_to_be_deleted) {
                  this.globalPrj.upload_to_be_deleted = [];
                }
                this.globalPrj.upload_to_be_deleted.push(((blockData.rows[i])[rowModulesIndex + ii.toString()])[subBlockName].value[iiTobd].id);
              }
            }
          }
        }
      }
    }

    blockData.rows.splice(i, noOfYears + 1);

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()
  }

  deleteTableRow(blockData, blockConf, i, tableIndex) {
    console.log('//---// DELETE TABLE ROW CALLED //---//');
    this.pendingChangesGuard.isPristine = false;
    this.globalPrj.isConfirmationSaved = false;

    if (blockConf.subBlocks) {
      for (let ii = 0; ii < blockConf.subBlocks.length; ii++) {
        if (blockConf.subBlocks[ii] && blockConf.subBlocks[ii].type === 'upload') {
          const subBlockName = blockConf.subBlocks[ii].name;
          if (blockData.budgetTables[tableIndex].rows[i][subBlockName].value) {
            for (let iiTobd = 0; iiTobd < blockData.budgetTables[tableIndex].rows[i][subBlockName].value.length; iiTobd++) {
              if (blockData.budgetTables[tableIndex].rows[i][subBlockName].value[iiTobd] && blockData.budgetTables[tableIndex].rows[i][subBlockName].value[iiTobd].fileUploaded) {
                if (!this.globalPrj.upload_to_be_deleted) {
                  this.globalPrj.upload_to_be_deleted = [];
                }
                this.globalPrj.upload_to_be_deleted.push(blockData.budgetTables[tableIndex].rows[i][subBlockName].value[iiTobd].id);
              }
            }
          }
        }
      }
    }
    blockData.budgetTables[tableIndex].rows.splice(i, 1);

    this.bphChange = _.cloneDeep(blockData);
    (this.globalPrj[this.selectedSectionId])[blockConf.name] = this.bphChange;

    if (blockConf.isDeleteRowFunctionActive) {
      if (typeof blockConf.afterDeleteRowFunction === 'function') {
        blockConf.afterDeleteRowFunction(this.globalPrj, this.globalConf, this, this.bphChange);
      };
    };

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()

  }

  getGlobalTotal(rows, column, j, row, currency, totalText, confChange) {
    if (totalText && !confChange.isCountRows) {
      return totalText[this.selectedLanguage];
    } else {
      let r = 0;
      if ((typeof column !== 'undefined') && column !== '') {
        for (let i = 0; i < rows.length; i++) {
          if (!rows[i].isTotal && !rows[i].skipTotal) {
            let newCellVal = 0;
            if (rows[i][column] && confChange.type === 'Checkbox') {
              const arr = rows[i][column]['value'];
              newCellVal = arr.filter(item => item.value === true).length;
            } else if (rows[i][column] && confChange.type === 'select') {
              const arr = rows[i][column]['value'];
              newCellVal = arr.value ? 1 : 0;
            } else if (rows[i][column] && confChange.type === 'text' && confChange.isCountRows) {
              const arr = rows[i][column]['value'];
              newCellVal = arr ? 1 : 0;
            } else if (rows[i][column] && !isNaN(parseInt(rows[i][column]['value'], 10))) {
              newCellVal = parseFloat(rows[i][column]['value']);
            }
            r = r + newCellVal;
          }
        }
        // r = Math.round(r * 10) / 10;
        const newTotalRow = {};
        newTotalRow['isTotal'] = true;
        newTotalRow['value'] = Math.round(r * 100) / 100;
      } else {
        r = null;
      }
      let currencySign = '0,0$';
      if (!currency) {
        currencySign = '0,0';
      }
      let total = '';
      if (confChange.inputSuffix) {
        total = (confChange.isCountRows ? (totalText[this.selectedLanguage] + ' ' + this.eCaseNumberFormatterPipe.transform(r, currency, null, this.selectedLanguage, null, confChange.decimalPlacesAllowed))
          : this.eCaseNumberFormatterPipe.transform(r, currency, null, this.selectedLanguage, null, confChange.decimalPlacesAllowed)) + ' ' + confChange.inputSuffix;
      } else {
        total = confChange.isCountRows ? (totalText[this.selectedLanguage] + ' ' + this.eCaseNumberFormatterPipe.transform(r, currency, null, this.selectedLanguage, null, confChange.decimalPlacesAllowed))
          : this.eCaseNumberFormatterPipe.transform(r, currency, null, this.selectedLanguage, null, confChange.decimalPlacesAllowed);
      }
      return total;
    }
  }

  calculateMultiplication(n1, n2) {
    let res = 0;
    try {
      if (n1 !== null && n2 !== null) {
        res = n1 * n2;
      }
    } catch (e) {
      return 0;
    }
    return res;
  }

  calculateDivision(n1, n2) {
    let res = 0;
    try {
      if (n1 !== null && n2 !== null && n2 !== 0) {
        res = n1 / n2;
      }
    } catch (e) {
      return 0;
    }
    return res;
  }

  getExpressionOutputNumber(row, label, lang, i) {
    let r;
    try {
      eval('r = ' + label);
    } catch (e) {
    }
    if (isNaN(r)) {
      r = '';
    }
    return r;
  }

  getExpressionOutput(row, label, lang, i) {
    let r = '';
    try {
      eval('r = ' + label);
    } catch (e) {
    }
    return r;
  };

  cancel(blockConf, blockData) {
    console.log('//---// CANCEL IN ROW DETAIL PRESSED //---//');
    console.log(blockConf);
    console.log(blockData);
    // Restore uploads state
    this.globalPrj.docsIds = this.tempDocIds;
    this.globalPrj.upload_to_be_deleted = this.tempUploadToBeDeleted;

    blockConf.showDetails = false;
    blockData.showDetails = false;
    this.globalConf.showDetails = false;
    const globalArray = [];
    for (const x in this.globalPrj[this.selectedSectionId]) {
      if (x !== blockConf.name) {
        globalArray.push(x);
      }
    }
    for (let k = 0; k < globalArray.length; k++) {
      try {
        ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).globalShowDetail = true;
        ((this.globalPrj[this.selectedSectionId])[globalArray[k]]).showDetails = false;
        ((this.globalConf[this.selectedSectionId])[globalArray[k]]).showDetails = false;
      } catch (e) {
      }
    }
    if (this.confChange.selectedContainerName) {
      console.log(this.globalPrj[this.selectedSectionId][this.confChange.selectedContainerName].rows);
      this.globalPrj[this.selectedSectionId][this.confChange.selectedContainerName].rows.forEach((row) => {
        if (row.sub_table) {
          row.sub_table.showDetails = false;
        }
      });
    }
    if (this.originalValueForShowSaveNavBar) {
      this.refreshDataService.toggleShowSaveNavBar(true);
    }
    console.log(this.copyBlockData);
    this.bphChange = _.cloneDeep(this.copyBlockData);
    this.bphChange.showDetails = false;
    if (this.teamTableBlockName && this.teamTableNestedTableBlockName) {
      this.globalPrj[this.selectedSectionId][this.teamTableBlockName].rows[this.teamTableIndex][this.teamTableNestedTableBlockName] = this.bphChange;
    } else {
      (this.globalPrj[this.selectedSectionId])[blockConf.name] = this.bphChange;
    }
    this.refreshDataService.tableCancelClicked(this.globalPrj);
    // setTimeout(() => {
    //   const element = document.getElementById(this.selectedSectionId + '_' + this.confChange.name);
    //   element.scrollIntoView();
    // }, 100);

    this.generateAndSortRowsToRender()
    this.generateSummaryTable()

    this.showAddEditTableForm = false;
  }

  isDialogOptionsEnabledForList(option): boolean {
    return this.confChange.showDialogForOptions && this.confChange.optionsDialogList.filter(item => item.id === option).length > 0;
  }

  openDialogForOptions(option): void {
    const dialogObj = this.confChange.optionsDialogList.filter(item => item.id = option)[0];
    this.openDialog(dialogObj);
  }

  ngOnDestroy(): void {
    this.confChange.showDetails = false;
    this.bphChange.showDetails = false;
    this.showDetails = false;
    this.globalConf.showDetails = false;

    if (this.originalValueForShowSaveNavBar) {
      this.refreshDataService.toggleShowSaveNavBar(true);
    }

    if (this.subscription)
      this.subscription.unsubscribe();

    if (this.formValidationSubscription)
      this.formValidationSubscription.unsubscribe();
  }

  showTableRow(row, index) {
    console.log(index);
    row.isShowTableRow = !row.isShowTableRow;
  }

  getTextLength2(l): number {
    try {
      l = l.toString();
      if (l.length > 9) {
        l = l.slice(0, 9);
      }
      return l.length;
    } catch (e) {
      return 0;
    }
  }

  onSubTotalInput2($event?) {
    if ($event) {
      const t = $event.target;
      if (t.hasAttribute('maxlength')) {
        t.value = t.value.slice(0, t.getAttribute('maxlength'));
      }
    }
  }

  onOtherInstitutionFundsInput(table, row) {
    let total = 0;
    if (row.expandRows) {
      for (const expandRow of row.expandRows) {
        total = +(total + expandRow.fundsFromOtherInstitution.value);
      }
    }
    if (!row.grandTotalForOtherFunds) {
      row.grandTotalForOtherFunds = {};
    }
    row.grandTotalForOtherFunds.value = total;
    this.pendingChangesGuard.isPristine = false;
  }

  onSubTotalInput(table, row, rowIndex, columnIndex, expandRow?, $event?) {
    console.log('//---// ON SUB TOTAL INPUT //---//');

    if ($event && expandRow.subTotal !== null) {
      const t = $event.target;
      if (t.hasAttribute('maxlength')) {
        t.value = t.value.slice(0, t.getAttribute('maxlength'));
        expandRow.value = (expandRow.value !== null &&
          expandRow.value !== undefined &&
          expandRow.value !== "") ? expandRow.value : (expandRow.item.allowEmptyValues ? "" : 0);
        if (expandRow.value !== "") {
          expandRow.value = +((expandRow.value).toString().slice(0, t.getAttribute('maxlength')));
        }
      }
    }

    let totals = {};
    row.expandRows.forEach(outerRow => {
      outerRow.totalComps.forEach(innerRow => {
        if (!(innerRow.item.name in totals)) {
          totals[innerRow.item.name] = 0
        }
        if (!isNaN(innerRow.value) && innerRow.value != "") {
          totals[innerRow.item.name] += parseFloat(innerRow.value);
        }
      })
    })

    Object.entries(totals).forEach(([key, value]) => {
      if (row?.[key]) {
        row[key].value = value == 0 ? (this.confChange[key].allowEmptyValues ? '' : 0) : value;
      } else {
        row[key] = {
          'value': value == 0 ? (this.confChange?.[key]?.allowEmptyValues ? '' : 0) : value,
          "globalShowDetail": true,
          "error": {},
          "error_class": ""
        }
      }
    })

    if (this.confChange.subTotalOutputEventFunctions) {
      for (const functionName of this.confChange.subTotalOutputEventFunctions) {
        if (this.confChange[functionName]) {
          this.confChange[functionName](rowIndex, columnIndex, row, expandRow, this.selectedLanguage, this.refreshDataService);
        }
      }
    }

    this.pendingChangesGuard.isPristine = false;
  }

  convertNumberToCurrencyFormat(value: any, currency: any, removeFraction: boolean = false): any {
    return this.confChange.isFormattingDisabled ? value : this.eCaseNumberFormatterPipe.transform(value, currency, this.selectedLanguage, removeFraction, currency);
  }

  filterInvalidCategories(categories: any): any {
    const validKeys = Object.keys(categories).filter(key => !key.includes('undefined'));
    const obj = cloneDeep(categories);
    Object.keys(obj).forEach((key) => {
      if (!validKeys.includes(key)) {
        delete categories[key];
      }
    });
    return categories;
  }

  sortArray(arr: any[]): any[] {
    return arr ? arr.sort((rowa, rowb) => {
      if (rowa.value.sortingKey < rowb.value.sortingKey) {
        return -1;
      } else if (rowa.value.sortingKey > rowb.value.sortingKey) {
        return 1;
      }
      return 0;
    }) : [];
  }

  generateSummaryTable() {
    console.log('//---// GENERATE SUMMARY BUDGET TABLE //---//');

    let sumTable = {
      yearTotals: cloneDeep(this.bphChange.yearRows),
      grandSubTotal: { 'value': 0, 'error': {} },
      rowsMap: {}
    };

    let rowSearchKey = this.confChange.showSubCategoryInSummary ? 'select_sub_category' : 'select_category';
    let sortingKey = 0;

    this.bphChange.budgetTables.forEach(table => {
      table.renderRows.forEach((row) => {
        if (row.uniqueRowIndex && row.select_category.value?.label && row.select_sub_category.value?.label) {
          if (!sumTable.rowsMap[row[rowSearchKey].value.value]) {
            sortingKey += 1;
            sumTable.rowsMap[row[rowSearchKey].value.value] = {
              sortingKey: sortingKey,
              rowTotal: { 'value': 0, 'error': {} },
              categoryLabel: row.select_category.value.label,
              categoryId: row.select_category?.value?.value,
              subCategoryLabel: row.select_sub_category.value.label,
              subCategoryId: row.select_sub_category?.value?.value,
              yearRows: cloneDeep(this.bphChange.yearRows)
            }
          }

          let subTotal;
          let generatedTotal = 0;
          row.expandRows.forEach((year, i) => {
            if (this.confChange.isAddExpandValuesToSummaryActive) {
              let value;
              generatedTotal += year.totalComps.reduce((sum, current) => {
                if (current.item?.removeFromSum) {
                  return sum;
                } else {
                  value = isNaN(current.value) ? 0 : Number(current.value);
                  return sum + value;
                }
              }, 0) || 0;

              subTotal = year.totalComps.reduce((sum, current) => {
                if (current.item?.removeFromSum) {
                  return sum;
                } else {
                  value = isNaN(current.value) ? 0 : Number(current.value);
                  return sum + value;
                }
              }, 0) || 0;

              subTotal = Math.floor(subTotal);
              generatedTotal = Math.floor(generatedTotal);
            } else {
              subTotal = Number(year.totalComps.find(obj => obj.item.name == 'total')?.value) || 0;
            }

            sumTable.rowsMap[row[rowSearchKey].value.value].yearRows[i].value += subTotal;
            sumTable.yearTotals[i].value += subTotal;
          })

          if (!generatedTotal) {
            generatedTotal = Number(row.total.value);
          }

          sumTable.rowsMap[row[rowSearchKey].value.value].rowTotal.value += generatedTotal || 0;
          sumTable.grandSubTotal.value += generatedTotal || 0;
        }
      });
    })

    sumTable['rows'] = Object.values(sumTable.rowsMap);
    this.bphChange.summaryTable = sumTable;
  }

  toggleTable(table) {
    if (table) {
      table.hidden = !table.hidden;
    }
  }

  checkForSelectNo($event, table) {
    console.log(`CHECK TABLE FOR SELECT\n${table.teamFunded}\n${table}`);
    if (table.teamFunded === '2') {
      table.hidden = true;
    } else {
      table.hidden = false;
    }
    this.generateSummaryTable();
  }

  getColumnAsRowSubBlocks() {
    if (!this.filteredSubBlocksColumnAsRowCache) {
      this.filteredSubBlocksColumnAsRowCache = this.confChange.subBlocks.filter((item: { columnAsRow: boolean }) => item.columnAsRow);
    }
    return this.filteredSubBlocksColumnAsRowCache;
  }

  checkRevisionMode(item: any) {
    return item.onlyRevisionMode && this.isFormRevisionMode;
  }

  getFilteredSubBlocks() {
    if (!this.filteredSubBlocksCache) {
      this.filteredSubBlocksCache = this.confChange.subBlocks.filter((item: { columnAsRow: boolean; onlyRevisionMode?: boolean }) =>
        !item.columnAsRow && (!item.onlyRevisionMode || this.isFormRevisionMode)
      )
    }
    return this.filteredSubBlocksCache;
  }

  getFilteredSubBlocksDetailedView() {
    if (!this.filteredSubBlocksDetailedCache) {
      this.filteredSubBlocksDetailedCache = this.confChange.subBlocks.filter((item: { hideCellInDetailView?: boolean }) => !item.hideCellInDetailView)
    }
    return this.filteredSubBlocksDetailedCache;
  }

  getColumnAsRowColspan() {
    const showDeleteButtonCount = this.confChange.showDelete ? 1 : 0;
    const showEditButtonCount = !this.confChange.hideEditButton ? 1 : 0;
    const deleteEditRowCount = showDeleteButtonCount + showEditButtonCount;

    const totalSubBlocks = this.confChange.subBlocks.length;
    const columnAsRowCount = this.confChange.subBlocks.filter((item: { columnAsRow: boolean }) => item.columnAsRow).length;

    // -1 represents the first column used for displaying the column label.
    this.columnAsRowColspan = totalSubBlocks - columnAsRowCount + deleteEditRowCount - 1;
    return this.columnAsRowColspan;
  }

  serialize(entity) {
    function recursiveSerialize(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj;
      }

      const serialized = Array.isArray(obj) ? [] : {};

      for (const key in obj) {
        if (key === 'templateContext' || key === 'templateContext2') {
          continue;
        }
        serialized[key] = recursiveSerialize(obj[key]);
      }
      return serialized;
    }
    return recursiveSerialize(entity);
  }

  private fixVersionsTotalComps() {
    this.bphChange.budgetTables.forEach(table => {
      table.rows.forEach((row) => {
        row.expandRows.forEach((expandRow) => {
          if (!expandRow.totalComps) {
            expandRow["totalComps"] = _.cloneDeep(this.expRowCompArr);
            expandRow.totalComps.forEach(obj => {
              if (obj.item.name == "total") {
                obj.value = expandRow.subTotal?.value;
              }
            })
          } else {
            expandRow.totalComps.forEach(obj => {
              obj.item = {
                name: obj.item.name,
                label: this.confChange[obj.item.name]?.label || {},
                hasDialog: this.confChange[obj.item.name]?.hasDialog || false,
                onlyRevisionMode: this.confChange[obj.item.name]?.onlyRevisionMode || false,
                allowEmptyValues: this.confChange[obj.item.name]?.allowEmptyValues || false,
                removeFromSum: this.confChange[obj.item.name]?.removeFromSum || false
              };
            })
          }
        })
      })
    })
  }

  getExpRowsCheckRevisionMode(totalComps: any) {
    return totalComps.filter((item: any) => (
      !item.item.onlyRevisionMode || this.isFormRevisionMode
    ));
  }

  private migrateExistingData(): void {
    if (!this.bphChange?.budgetTables) {
      return;
    }

    try {
      this.bphChange.budgetTables.forEach((table, tableIndex) => {
        if (table.migrated) {
          return;
        }

        if (table.rows && Array.isArray(table.rows)) {
          table.rows.forEach((row, rowIndex) => {
            this.migrateRow(row);
          });
        }

        table.migrated = true;

        this.refreshDataService.tableCancelClicked(this.globalPrj);
      });
    } catch (error) {
      console.warn('Migration failed:', error);
    }
  }

  private migrateRow(row: any): void {
    if (!row || typeof row !== 'object') {
      return;
    }

    if (row.select_category?.list && Array.isArray(row.select_category.list)) {
      if (row.select_category.value?.value && !row.select_category.value.label) {
        const selectedItem = row.select_category.list.find(item => item.value === row.select_category.value.value);
        if (selectedItem) {
          row.select_category.value.label = selectedItem.label;
        }
      }

      delete row.select_category.list;
      row.select_category.useGlobalList = true;
    }

    if (row.select_sub_category?.list && Array.isArray(row.select_sub_category.list)) {
      if (row.select_sub_category.value?.value && !row.select_sub_category.value.label) {
        const selectedItem = row.select_sub_category.list.find(item => item.value === row.select_sub_category.value.value);
        if (selectedItem) {
          row.select_sub_category.value.label = selectedItem.label;
        }
      }

      delete row.select_sub_category.list;
      row.select_sub_category.useGlobalList = true;

      if (row.select_category?.value?.value) {
        row.select_sub_category.parentCategoryId = row.select_category.value.value;
      }
    }
  }

  onCategoryChange(row: any, newCategoryId: any): void {
    if (row.select_sub_category?.useGlobalList && newCategoryId) {
      row.select_sub_category.parentCategoryId = newCategoryId;
      row.select_sub_category.value = { value: '', label: {} };
    }
  }

  saveBudgetToDb(blockData: any): void {
    if (!blockData?.budgetTables?.length) { return; }

    const budgetData = blockData.budgetTables.flatMap(budgetTable =>
      (budgetTable.rows || [])
        .filter(row => row.select_sub_category?.value?.value)
        .map(row => ({
          budgetItemId: Number(row.select_sub_category.value.value),
          description: row.textarea_description?.value || '',
          caseApplicationTeamId: budgetTable.caseApplicationTeamId || this.globalPrj.caseApplicationPiTeamId,
          costs: row.expandRows.map(expandRow => ({
            year: expandRow.year,
            amount: Number(expandRow.totalComps?.[0]?.value || expandRow.subTotal?.value || 0)
          })),
          rowCode: row.rowCode
        }))
    );

    if (!budgetData.length) { return; }

    this.eCaseHttpService.post('/api/addOrUpdateCaseApplicationTeamBudget', budgetData).subscribe((response) => {
      console.log(response);
    });

  }

  getLabelLines(table): string[] {
    if (!table?.label) return [];

    const lang = this.selectedLanguage;
    const raw = table.label[lang];
    if (!raw) return [];

    table.labelLinesCache = table.labelLinesCache || {};
    const cached = table.labelLinesCache[lang];
    if (cached && cached.raw === raw && cached.locked === table.isLabelLocked) {
      return cached.lines;
    }

    const lines = Array.isArray(raw)
      ? raw
      : String(raw).split(/\r?\n/);

    const cleaned = lines
      .map((line) => String(line ?? '').replace(/[\u00A0\s]+/g, ' ').trim())
      .filter(Boolean);

    table.labelLinesCache[lang] = { raw, locked: table.isLabelLocked, lines: cleaned };
    return cleaned;
  }

}
